import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Button, PasswordInput, EmailInput} from '../Presentation/Forms';
import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Loader from '../Presentation/Loader';

import {loginAction} from '../../actions/Auth';

class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            emailError: null,
            passwordError: null,
        };
        this.login = this.login.bind(this);
    }

    login(e) {
        e.preventDefault();

        let newState = {
            emailError: null,
            passwordError: null,
        };
        let valid = true;

        const {email, pass} = this.getInputValues();

        if (!email) {
            valid = false;
            newState.emailError = "Полето е задължително";
        }

        if (!pass) {
            valid = false;
            newState.passwordError = "Полето е задължително";
        }

        if (valid) {
            const loginArgs = {
                email: this.refs.email.getValue(),
                password: this.refs.pass.getValue()
            };

            this.dispatchLogin(loginArgs);
        }

        this.setState(newState);
    }

    dispatchLogin(args) {
        this.props.dispatch(loginAction(this.dispatchLogin.bind(this, args), args));
    }

    getInputValues() {
        return {
            email: this.refs.email ? this.refs.email.getValue() : "",
            pass: this.refs.pass ? this.refs.pass.getValue() : ""
        }
    }

    render() {
        const {loginPending, credentialsError} = this.props;
        const {email, pass} = this.getInputValues();
        const {emailError, passwordError} = this.state;

        return <FullWidthPage title="Вход">
            <form className="profile-form login ">
                <Loader show={loginPending} />
                <div className={loginPending ? "loading" : ""}>
                    <div className="col-md-8 col-md-offset-2">
                        <SectionTitle>Влез в профила си</SectionTitle>
                        <EmailInput error={emailError || credentialsError} ref="email" value={email} id="email" name="email" required="required" label="Имейл Адрес" />
                        <PasswordInput error={passwordError || credentialsError} ref="pass" value={pass} id="pass" name="pass" required="required" label="Парола" />
                        <div className="text-right"><Link to="/forgotten-password">Забравена парола</Link></div>
                        <div className="text-center">
                            <Button clickHandler={this.login} text="Вход"/>
                        </div>

                        <div className="text-center">
                            <h4 className="section-separator-text">или</h4>
                            <div className="cta-text">Регистрирай се безплатно</div>
                            <div>
                                <Link to="/register" className="btn btn-default">Регистрирай се</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {
        loginPending: state.auth.loginPending,
        credentialsError: state.auth.loginError
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(LoginPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Login.js